module.exports = __webpack_public_path__ + "static/img/background.6170037c.svg";